var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrashRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 4.80664L16.9887 13.5785C16.8505 15.8194 16.7814 16.9403 16.2188 17.7461C15.941 18.1444 15.5834 18.4805 15.1687 18.7331C14.3314 19.2441 13.2088 19.2441 10.9635 19.2441C8.71475 19.2441 7.59037 19.2441 6.75125 18.7323C6.3364 18.4792 5.97881 18.1424 5.70125 17.7435C5.1395 16.9368 5.07125 15.8141 4.9365 13.5698L4.40625 4.80664M3.09375 4.80664H18.8438M14.5177 4.80664L13.9201 3.57464C13.5238 2.75564 13.3251 2.34702 12.983 2.09152C12.907 2.03492 12.8265 1.98458 12.7424 1.94102C12.3635 1.74414 11.9085 1.74414 10.9994 1.74414C10.0666 1.74414 9.60025 1.74414 9.21437 1.94889C9.12908 1.99458 9.04771 2.04726 8.97113 2.10639C8.6255 2.37152 8.43213 2.79589 8.04538 3.64377L7.51513 4.80664M8.78125 14.4316V9.18164M13.1562 14.4316V9.18164",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashRed);
export default __webpack_public_path__ + "static/media/icon-trash-red.4ca895d66cfc42ecac5fbb00303cb734.svg";
export { ForwardRef as ReactComponent };